export const environment = {
  production: true,
  environmentName: 'Docker',
  baseUrl: 'https://glicosus-api.v2z9dg.easypanel.host/',
  googleMapsApiKey: '',
}
